// Generated by Melange

import * as Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment from "./buhta_payroll_hrm_v1alpha1_employment.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_type__Google_type_date from "../../third_party/google_type/gen/google_type_date.js";
import * as Google_wkt__Google_protobuf_timestamp from "../../third_party/google_wkt/gen/google_protobuf_timestamp.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employee.ml",
      88,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "Employee"
                          ]]
                      },
                      "V1alpha1"
                    ]]
                },
                "Hrm"
              ]]
          },
          "Payroll"
        ]]
    });

const Payroll = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employee.ml",
      136,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Employee"
                    ]]
                },
                "V1alpha1"
              ]]
          },
          "Hrm"
        ]]
    });

const Hrm = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employee.ml",
      182,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Employee"
              ]]
          },
          "V1alpha1"
        ]]
    });

const V1alpha1 = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employee.ml",
      226,
      12
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Employee"
        ]]
    });

const Employee = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employee.ml",
      268,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.payroll.hrm.v1alpha1.Employee";
}

function make(idOpt, serial_idOpt, tinOpt, family_nameOpt, given_nameOpt, patronymic_nameOpt, birthday_date, address, emailOpt, phoneOpt, employment, create_time, update_time, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const serial_id = serial_idOpt !== undefined ? serial_idOpt : 0;
  const tin = tinOpt !== undefined ? tinOpt : "";
  const family_name = family_nameOpt !== undefined ? family_nameOpt : "";
  const given_name = given_nameOpt !== undefined ? given_nameOpt : "";
  const patronymic_name = patronymic_nameOpt !== undefined ? patronymic_nameOpt : "";
  const email = emailOpt !== undefined ? emailOpt : "";
  const phone = phoneOpt !== undefined ? phoneOpt : "";
  return {
          id: id,
          serial_id: serial_id,
          tin: tin,
          family_name: family_name,
          given_name: given_name,
          patronymic_name: patronymic_name,
          birthday_date: birthday_date,
          address: address,
          email: email,
          phone: phone,
          employment: employment,
          create_time: create_time,
          update_time: update_time
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_serial_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "serial_id",
            "serialId"
          ],
          Ocaml_protoc_plugin__Spec.int64_int,
          0
        ]));

const merge_tin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "tin",
            "tin"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_family_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "family_name",
            "familyName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_given_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "given_name",
            "givenName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_patronymic_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            6,
            "patronymic_name",
            "patronymicName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let = Google_type__Google_type_date.Google.Type.$$Date;

const merge_birthday_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            7,
            "birthday_date",
            "birthdayDate"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

const merge_address = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            8,
            "address",
            "address"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_email = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            9,
            "email",
            "email"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_phone = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            10,
            "phone",
            "phone"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let$1 = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment.Buhta.Payroll.Hrm.V1alpha1.Employment;

const merge_employment = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            21,
            "employment",
            "employment"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

const $$let$2 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_create_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            51,
            "create_time",
            "createTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              })
        ]));

const $$let$3 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_update_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            52,
            "update_time",
            "updateTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

function merge(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          serial_id: Curry._2(merge_serial_id, t1.serial_id, t2.serial_id),
          tin: Curry._2(merge_tin, t1.tin, t2.tin),
          family_name: Curry._2(merge_family_name, t1.family_name, t2.family_name),
          given_name: Curry._2(merge_given_name, t1.given_name, t2.given_name),
          patronymic_name: Curry._2(merge_patronymic_name, t1.patronymic_name, t2.patronymic_name),
          birthday_date: Curry._2(merge_birthday_date, t1.birthday_date, t2.birthday_date),
          address: Curry._2(merge_address, t1.address, t2.address),
          email: Curry._2(merge_email, t1.email, t2.email),
          phone: Curry._2(merge_phone, t1.phone, t2.phone),
          employment: Curry._2(merge_employment, t1.employment, t2.employment),
          create_time: Curry._2(merge_create_time, t1.create_time, t2.create_time),
          update_time: Curry._2(merge_update_time, t1.update_time, t2.update_time)
        };
}

function spec(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  const $$let$1 = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment.Buhta.Payroll.Hrm.V1alpha1.Employment;
  const $$let$2 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$3 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "serial_id",
                        "serialId"
                      ],
                      Ocaml_protoc_plugin__Spec.int64_int,
                      0
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "tin",
                            "tin"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "family_name",
                                "familyName"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              ""
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    5,
                                    "given_name",
                                    "givenName"
                                  ],
                                  Ocaml_protoc_plugin__Spec.string,
                                  ""
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                      [
                                        6,
                                        "patronymic_name",
                                        "patronymicName"
                                      ],
                                      Ocaml_protoc_plugin__Spec.string,
                                      ""
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                          [
                                            7,
                                            "birthday_date",
                                            "birthdayDate"
                                          ],
                                          Ocaml_protoc_plugin__Spec.message({
                                                name: $$let.name,
                                                make: $$let.make,
                                                from_proto: $$let.from_proto,
                                                from_proto_exn: $$let.from_proto_exn,
                                                to_proto: $$let.to_proto,
                                                to_proto$p: $$let.to_proto$p,
                                                merge: $$let.merge,
                                                to_json: $$let.to_json,
                                                from_json_exn: $$let.from_json_exn,
                                                from_json: $$let.from_json
                                              })
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                              [
                                                8,
                                                "address",
                                                "address"
                                              ],
                                              Ocaml_protoc_plugin__Spec.string
                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                  [
                                                    9,
                                                    "email",
                                                    "email"
                                                  ],
                                                  Ocaml_protoc_plugin__Spec.string,
                                                  ""
                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                      [
                                                        10,
                                                        "phone",
                                                        "phone"
                                                      ],
                                                      Ocaml_protoc_plugin__Spec.string,
                                                      ""
                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                          [
                                                            21,
                                                            "employment",
                                                            "employment"
                                                          ],
                                                          Ocaml_protoc_plugin__Spec.message({
                                                                name: $$let$1.name,
                                                                make: $$let$1.make,
                                                                from_proto: $$let$1.from_proto,
                                                                from_proto_exn: $$let$1.from_proto_exn,
                                                                to_proto: $$let$1.to_proto,
                                                                to_proto$p: $$let$1.to_proto$p,
                                                                merge: $$let$1.merge,
                                                                to_json: $$let$1.to_json,
                                                                from_json_exn: $$let$1.from_json_exn,
                                                                from_json: $$let$1.from_json
                                                              })
                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                              [
                                                                51,
                                                                "create_time",
                                                                "createTime"
                                                              ],
                                                              Ocaml_protoc_plugin__Spec.message({
                                                                    name: $$let$2.name,
                                                                    make: $$let$2.make,
                                                                    from_proto: $$let$2.from_proto,
                                                                    from_proto_exn: $$let$2.from_proto_exn,
                                                                    to_proto: $$let$2.to_proto,
                                                                    to_proto$p: $$let$2.to_proto$p,
                                                                    merge: $$let$2.merge,
                                                                    to_json: $$let$2.to_json,
                                                                    from_json_exn: $$let$2.from_json_exn,
                                                                    from_json: $$let$2.from_json
                                                                  })
                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                  [
                                                                    52,
                                                                    "update_time",
                                                                    "updateTime"
                                                                  ],
                                                                  Ocaml_protoc_plugin__Spec.message({
                                                                        name: $$let$3.name,
                                                                        make: $$let$3.make,
                                                                        from_proto: $$let$3.from_proto,
                                                                        from_proto_exn: $$let$3.from_proto_exn,
                                                                        to_proto: $$let$3.to_proto,
                                                                        to_proto$p: $$let$3.to_proto$p,
                                                                        merge: $$let$3.merge,
                                                                        to_json: $$let$3.to_json,
                                                                        from_json_exn: $$let$3.from_json_exn,
                                                                        from_json: $$let$3.from_json
                                                                      })
                                                                ]), Ocaml_protoc_plugin__Spec.nil)))))))))))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry.app(serialize, [
        writer,
        param.id,
        param.serial_id,
        param.tin,
        param.family_name,
        param.given_name,
        param.patronymic_name,
        param.birthday_date,
        param.address,
        param.email,
        param.phone,
        param.employment,
        param.create_time,
        param.update_time
      ]);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, serial_id, tin, family_name, given_name, patronymic_name, birthday_date, address, email, phone, employment, create_time, update_time) {
  return {
          id: id,
          serial_id: serial_id,
          tin: tin,
          family_name: family_name,
          given_name: given_name,
          patronymic_name: patronymic_name,
          birthday_date: birthday_date,
          address: address,
          email: email,
          phone: phone,
          employment: employment,
          create_time: create_time,
          update_time: update_time
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.Employee", spec(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
                param.id,
                param.serial_id,
                param.tin,
                param.family_name,
                param.given_name,
                param.patronymic_name,
                param.birthday_date,
                param.address,
                param.email,
                param.phone,
                param.employment,
                param.create_time,
                param.update_time
              ]);
  };
}

function constructor$1(id, serial_id, tin, family_name, given_name, patronymic_name, birthday_date, address, email, phone, employment, create_time, update_time) {
  return {
          id: id,
          serial_id: serial_id,
          tin: tin,
          family_name: family_name,
          given_name: given_name,
          patronymic_name: patronymic_name,
          birthday_date: birthday_date,
          address: address,
          email: email,
          phone: phone,
          employment: employment,
          create_time: create_time,
          update_time: update_time
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.Employee", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, Employee, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Employee"
        ]]
    }, V1alpha1, {
      Employee: Employee
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Employee"
              ]]
          },
          "V1alpha1"
        ]]
    }, Hrm, {
      V1alpha1: V1alpha1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Employee"
                    ]]
                },
                "V1alpha1"
              ]]
          },
          "Hrm"
        ]]
    }, Payroll, {
      Hrm: Hrm
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "Employee"
                          ]]
                      },
                      "V1alpha1"
                    ]]
                },
                "Hrm"
              ]]
          },
          "Payroll"
        ]]
    }, Buhta, {
      Payroll: Payroll
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
